// extracted by css-extract-rspack-plugin
export default {"root":"root-hjiuOa","rowItem":"rowItem-hiD3LQ","svg":"svg-s3SkY_"};